"use client";

import { useGridSelector } from "@repo/lib/hooks/common";
import { IconGridChangeFourCol, IconGridChangeFourColActive, IconGridChangeThreeCol, IconGridChangeThreeColActive } from "@repo/assets/images";
import cx from "classnames";
const GridSelector = ({
  initialColumns
}) => {
  const {
    handleGridChange,
    currentColumns
  } = useGridSelector(initialColumns);
  return <>
      <div className="hidden items-center sm:flex">
        <button className={cx("border-toolbar-border h-[44px] w-[44px] border", {
        "bg-toolbar-activeBg shadow-inner": currentColumns === 3
      })} onClick={() => handleGridChange(3)} aria-label="3 column grid">
          {currentColumns === 3 ? <IconGridChangeThreeColActive className="text-toolbar-activeIcon mx-auto fill-current" /> : <IconGridChangeThreeCol className="text-toolbar-icon mx-auto fill-current" />}
        </button>
        <button className={cx("border-toolbar-border h-[44px] w-[44px] border", {
        "bg-toolbar-activeBg shadow-inner": currentColumns === 4
      })} onClick={() => handleGridChange(4)} aria-label="4 column grid">
          {currentColumns === 4 ? <IconGridChangeFourColActive className="text-toolbar-activeIcon mx-auto fill-current" /> : <IconGridChangeFourCol className="text-toolbar-icon mx-auto fill-current" />}
        </button>
      </div>
    </>;
};
export default GridSelector;